import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CustomerInvoices from './customerInvoices';
import BulkUpdate from './bulkUpdate'; // Import the BulkUpdate component
import { useNavigate } from 'react-router-dom';
import './InvoiceDashboard.css';
import { Link } from 'react-router-dom';
import { FaCog } from 'react-icons/fa';
import Switch from '@mui/material/Switch';
import {isAuthTokenValid} from './components/utils';

const InvoiceDashboard = () => {
  const [customerNames, setCustomerNames] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCustomerNames, setFilteredCustomerNames] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dropdownSize, setDropdownSize] = useState(1);
  const [searchActive, setSearchActive] = useState(false);
  const [allCustomer, setAllCustomer] = useState(false); 
  const [sendBatch,setSendBatch] = useState('');
  const [getNextBatch,setGetNextBatch] = useState(false);
  const [pageSize,setPageSize] = useState('');
  const [markSent,setMarkSent] = useState(false);
  const [toggleFetchNext,setToggleFetchNext] = useState(false);

  const orgID = '837447409';
  const navigate = useNavigate();
  const serverURL = process.env.REACT_APP_SERVER_BASE_URL;
  //const urlParams = new URLSearchParams(window.location.search);

  
  
  useEffect(() => {
   const accessToken = localStorage.getItem('access_token');
    const preferences = JSON.parse(localStorage.getItem('userPreferences'));
    let customerStatus = 'Status.Active';
    if (preferences) {
      customerStatus = preferences.customerStatus || '';
    }


    setIsLoading(true);
    const fetchCustomerNames = async () => {
       // const response = await axios.get('/get-access-token');
       // const accessToken = response.data.accessToken;
        if (!isAuthTokenValid()) {
            navigate('/authentication');
            return;
          }
      try {
        const response = await axios.get(serverURL+"/getCustomers",{
            params: {
                accessToken: accessToken
              }
        } );
        //const response = await axios.get('/getCustomers');
        setCustomerNames(response.data.response.contacts);
        //console.log("Customer API Response: ",response);
      } catch (error) {
        console.error('Error fetching customer names:', error);
       // localStorage.removeItem('access_token');
        //navigate('/authentication');
      } finally {
        setIsLoading(false);
      }
    };

    fetchCustomerNames();
    setIsLoading(false);
  }, []);

  useEffect(() => {
    setFilteredCustomerNames(
      customerNames.filter((customer) =>
        customer.customer_name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [customerNames, searchTerm]);

  const handleCustomerChange = (event) => {
    setSelectedCustomer(event.target.value);
    setSearchTerm('');
    setSearchActive(false); 
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setSelectedCustomer('');
    setDropdownSize(event.target.value ? filteredCustomerNames.length + 1 : 1);
    setSearchActive(true); 
  };

  const toggleUseCustomer = () => {
    setAllCustomer(!allCustomer); 
  };

  const handleSend = (event) => {
    setMarkSent(!markSent);
  };

  const handleNextBatch = (event) => {
    //same as handle send but makes a new call
    if(pageSize) {
        setSendBatch(pageSize);
        setGetNextBatch(true);
        setToggleFetchNext(!toggleFetchNext);
    }
  }

  const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
    console.log("Page size changed to: ",pageSize);
  }
  
  return (
    <div>
      {isLoading ? (
        <p>Loading.......</p>
      ) : (
        <div className="invoice-dashboard">
          <div className="settings-icon">
            <Link to="/user-preference" >
                <FaCog />
            </Link>
          </div>
          <div className="toggle-container">
            <label htmlFor="use-customer">All Customers</label>
            <Switch
              checked={allCustomer}
              onChange={toggleUseCustomer}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </div>

          {allCustomer ? (
            <>
            <div className="bulk-update-container">
              <label htmlFor="num-invoices">Number of Invoices:</label>
              <input type="number" id="num-invoices"
              onChange={handlePageSizeChange}
              />
              <div className="bulk-button-container">
                <button className='button-bulk-action'  onClick={handleNextBatch}>Get Next Batch</button> 
                <button className='button-bulk-action' onClick={handleSend}>Mark as Sent</button>
              </div>
            </div>
             {getNextBatch && <BulkUpdate pageSize={sendBatch} markSent={markSent} toggleGetInvoices={toggleFetchNext}/>}
             </>
          ) : (
            <>
              <div className="search-container">
                <label htmlFor="search">Search Customer:</label>
                <input
                  type="text"
                  id="search"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  placeholder="Search for customer..."
                />
              </div>
              <div className="select-container">
                <label htmlFor="customer">Select Customer:</label>
                <select 
                  id="customer" 
                  value={selectedCustomer} 
                  onChange={handleCustomerChange}
                  size={searchActive ? dropdownSize : 1 }
                >
                  <option value="">-- Select Customer --</option>
                  {filteredCustomerNames.map((customer) => (
                    <option key={customer.customer_name} value={customer.customer_name}>
                      {customer.customer_name}
                    </option>
                  ))}
                </select>
              </div>
              {selectedCustomer && <CustomerInvoices customerName={selectedCustomer} />}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default InvoiceDashboard;
